import { billingArticles } from './billing';
import { settingsArticles } from './settings';
import { troubleshootingArticles } from './troubleshooting';
import { advancedArticles } from './advanced';

const articles = [
  ...billingArticles,
  ...settingsArticles,
  ...troubleshootingArticles,
  ...advancedArticles
];

export default articles; 